<p-toast></p-toast>
<ckeditor [editor]="Editor" [(ngModel)]="emailBody"></ckeditor>
<textarea [(ngModel)]="emailBody" class="text-area" cols="200" rows="40"></textarea>
<div>
    <button (click)="sendTestEmail()">Send</button>
</div>

